module.exports = __webpack_public_path__ + "img/09d.bc059486.svg";